import { IMAGES_ENDPOINT_NO_STATIC } from "@icarius-connection/endpoints";
import paths from "@icarius-router/paths";
import { PRIZE_TYPES } from "@icarius-pages/recognitionPlans/constants";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

const createHeaderTemplate = (type) => {

    let imgTag = `<img src=${IMAGES_ENDPOINT_NO_STATIC + 'images/recognition/' + type}.png alt=${getLocalizedString(PRIZE_TYPES[type].name)} style="height: 30px" />`;

    return (
        '<div class="ag-cell-label-container" role="presentation">' +
        '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
        '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
        '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
        '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
        '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
        '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
        imgTag +
        '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
        '  </div>' +
        '</div>'
    )
}

export default () => [
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Nombre del plan",
            headerName: getLocalizedString("planName"),
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Estado del plan",
            headerName: getLocalizedString("planStatus"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Foto del colaborador",
            headerName: getLocalizedString("employeePhoto"),
            filter: "agTextColumnFilter",
            cellRenderer: "AvatarRenderer",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("code"),
            field: "Código de empleado",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: "Apellidos y nombres",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Puntos acumulados",
            headerName: getLocalizedString("accumulatedPoints"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Estado empleado en el plan",
            headerName: getLocalizedString("employeeStatusInPlan"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Fecha de asignación el plan",
            headerName: getLocalizedString("planAssignmentDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Última fecha de reconocimiento",
            headerName: getLocalizedString("lastRecognitionDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Medallas de bronce",
            headerName: getLocalizedString("bronzeMedals"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            headerComponentParams: {
                template: createHeaderTemplate('bronzeMedal')
            }
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Medallas de plata",
            headerName: getLocalizedString("silverMedals"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            headerComponentParams: {
                template: createHeaderTemplate('silverMedal')
            }
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Medallas de oro",
            headerName: getLocalizedString("goldMedals"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            headerComponentParams: {
                template: createHeaderTemplate('goldMedal')
            }
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Escudos de bronce",
            headerName: getLocalizedString("bronzeShields"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            headerComponentParams: {
                template: createHeaderTemplate('bronzeShield')
            }
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Escudos de plata",
            headerName: getLocalizedString("silverShields"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            headerComponentParams: {
                template: createHeaderTemplate('silverShield')
            }
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Escudos de oro",
            headerName: getLocalizedString("goldShields"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            headerComponentParams: {
                template: createHeaderTemplate('goldShield')
            }
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Ranking",
            headerName: getLocalizedString("ranking"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            cellRenderer: 'RatingRenderer',
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("recognitionTotalAmount"),
            field: "Cantidad total de reconocimientos",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("fType"),
            field: "Tipo de funcionario",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("position"),
            field: "Cargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("function"),
            field: "Función",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("management"),
            field: "Gerencia",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("department"),
            field: "Departamento",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: "Centro de costo de gestión",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "Tipo de contrato",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: "Fecha de contratación",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "Lugar de trabajo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: "Obra o Faena",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("sex"),
            field: "Sexo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("age"),
            field: "Edad",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "Grupo etario",
            headerName: getLocalizedString("ageGroup"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            headerName: getLocalizedString("nationality"),
            field: "Nacionalidad",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.recognitionAnalysis],
        config: {
            field: "País de residencia",
            headerName: getLocalizedString("countryOfResidence"),
            filter: "agSetColumnFilter",
        }
    },
]